import { img } from "./images";

export interface Doctor {
  slug: string;
  name: string;
  honorific: string;
  qualifications: string[];
  specialty: string;
  role: string;
  phone: string;
  phoneDisplay: string;
  expertise: string[];
  services: string[];
  bio: string;
  consultationNote: string;
  image: string;
  imageBackdrop: string;
  imageAlt: string;
}

export const doctors: Doctor[] = [
  {
    slug: "dr-m-v-arun-vijaiyan",
    name: "Dr. M. V. Arun Vijaiyan",
    honorific: "Dr.",
    qualifications: ["M.S.", "M.Ch., (Uro)"],
    specialty: "Urologist & Andrologist",
    role: "Urology & Andrology Specialist",
    phone: "+919442445579",
    phoneDisplay: "+91 94424 45579",
    expertise: [
      "Kidney stone evaluation & management",
      "Endourology & laser stone procedures",
      "Prostate-related conditions",
      "Male urinary health",
      "Male reproductive health",
      "Male infertility consultation",
      "Men's sexual health",
      "Urological consultation",
    ],
    services: [
      "kidney-stones",
      "urinary-problems",
      "prostate-care",
      "endourology",
      "male-urinary-health",
      "male-infertility",
      "male-reproductive-health",
      "mens-health",
    ],
    bio: "Dr. M. V. Arun Vijaiyan is a Urologist and Andrologist at AV Clinic, Krishnagiri. He focuses on accurate diagnosis and individualised management of urological and male health concerns — including kidney stone care, endourological and laser stone procedures where appropriate, prostate-related conditions, and male reproductive and sexual health. His approach is patient-centred, with a strong emphasis on clear communication, patient education and a comfortable clinical experience.",
    consultationNote:
      "Consultations with Dr. Arun Vijaiyan are available at AV Clinic, Krishnagiri. Please call to confirm current clinic hours.",
    image: img.doctorArun,
    imageBackdrop: img.doctorArun,
    imageAlt: "Dr. M. V. Arun Vijaiyan, Urologist and Andrologist at AV Clinic, Krishnagiri",
  },
  {
    slug: "dr-m-vanitha",
    name: "Dr. M. Vanitha",
    honorific: "Dr.",
    qualifications: ["M.B.B.S.", "D.D.V.L."],
    specialty: "Dermatologist",
    role: "Dermatology Specialist",
    phone: "+919489828646",
    phoneDisplay: "+91 94898 28646",
    expertise: [
      "Acne & acne scar management",
      "Pigmentation & melasma care",
      "Psoriasis, eczema & skin disorders",
      "Fungal & skin infections",
      "Vitiligo & urticaria",
      "Nail & scalp disorders",
      "Hair fall evaluation",
      "Aesthetic dermatology & skin care",
    ],
    services: [
      "acne",
      "acne-scars",
      "pigmentation",
      "melasma",
      "psoriasis",
      "eczema",
      "fungal-infections",
      "hair-loss",
      "dandruff",
      "scalp-disorders",
    ],
    bio: "Dr. M. Vanitha is a Dermatologist at AV Clinic, Krishnagiri, qualified with an M.B.B.S. and D.D.V.L. She provides specialist care for a wide range of skin, hair and nail conditions — from acne and pigmentation to psoriasis, eczema, fungal infections and hair fall. Her practice combines accurate diagnosis with practical, personalised treatment plans and clear guidance, helping patients manage long-term skin and hair health with confidence.",
    consultationNote:
      "Consultations with Dr. Vanitha are available at AV Clinic, Krishnagiri. Please call to confirm current clinic hours.",
    image: img.doctorVanitha,
    imageBackdrop: img.doctorVanitha,
    imageAlt: "Dr. M. Vanitha, Dermatologist at AV Clinic, Krishnagiri",
  },
];

export const getDoctor = (slug: string) => doctors.find((d) => d.slug === slug);